import { Close, DeleteOutline, PlaylistPlay } from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
  useTheme,
  Zoom,
} from "@mui/material";
import { ReactNode } from "react";
import { useStyles } from "./styles";

export interface SectionBarProps {
  selectedCount: number;
  label: string;
  disabled?: boolean;
  onRunTests?: () => void;
  onDelete?: () => void;
  onClearSelection?: () => void;
  extraActions?: ReactNode;
}

export default function SectionBar(props: SectionBarProps) {
  const {
    selectedCount,
    label,
    disabled = false,
    onRunTests,
    onDelete,
    onClearSelection,
    extraActions,
  } = props;

  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Stack alignItems={"center"} sx={styles.boxBar}>
      <Zoom in={selectedCount > 0} unmountOnExit>
        <Paper sx={styles.paperBar} elevation={6}>
          <Stack direction="row" gap={1} alignItems="center">
            <Box sx={styles.badgeCount}>{selectedCount}</Box>
            <Typography variant="body2" fontWeight="500">
              {label}
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" gap={1}>
            {extraActions}

            {onRunTests && (
              <Button
                variant="text"
                size="small"
                disabled={disabled}
                onClick={onRunTests}
                startIcon={<PlaylistPlay />}
              >
                Executar testes
              </Button>
            )}

            {onRunTests && onDelete && (
              <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
            )}

            {onDelete && (
              <Button
                variant="text"
                size="small"
                color="error"
                disabled={disabled}
                onClick={onDelete}
                startIcon={<DeleteOutline />}
              >
                Excluir
              </Button>
            )}

            {onClearSelection && (
              <>
                <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
                <Tooltip title="Limpar seleção">
                  <span>
                    <IconButton
                      size="small"
                      disabled={disabled}
                      onClick={onClearSelection}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </>
            )}
          </Stack>
        </Paper>
      </Zoom>
    </Stack>
  );
}
